import { Box } from "@mui/material";
import ContentWrap from "@/DocLayout/Content/Index";
import { FAILT_LIST } from "@/config";
import CodeSnippet from "@/components/CodeSnippet";
import Table from "@/DocLayout/Table";
import { useLocales } from "@/locales";
import { CommonWrap } from "../common";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import { codeMap } from "@/PageCodeComponents/PublicResourceApi";
import PostRequest from "@/components/PostRequest";
export default function Index({ url: FAILT_LIST_ }: { url: string }) {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const fait_list = {
    response: `{
  "code": 10000,
  "msg": "success",
  "data": {
    "fiats": [
      {
        "fiatId": 1022,
        "symbol": "DKK",
        "logoUrl": "https://resource.cwallet.com/fiat/DKK.png",
        "mark": "KR",
        "usdRate": "6.825765"
      },
      ...
    ]
  }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
  "bytes"
  "crypto/hmac"
  "crypto/sha256"
  "encoding/hex"
  "fmt"
  "io"
  "net/http"
  "time"
  )
  
  func main() {
  
  appId := "*** your appId ***"
  appSecret := "*** your appSecret ***"
  
  // With request params
  path := "${FAILT_LIST_}"
  args := []byte(${"``"})
  
  //sign
  timestamp := time.Now().Unix()
  
  signText := fmt.Sprintf("%s%d", appId, timestamp)
  if len(args) != 0 {
      signText = fmt.Sprintf("%s%s", signText, args)
  }
  
  h := hmac.New(sha256.New, []byte(appSecret))
  h.Write([]byte(signText))
  sign := hex.EncodeToString(h.Sum(nil)[:])
  
  fmt.Println("Sign: %s", sign)
  
  // Making API call
  client := http.Client{}
  request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
  request.Header.Set("Appid", appId)
  request.Header.Set("Sign", sign)
  request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
  resp, _ := client.Do(request)
  
  defer resp.Body.Close()
  respBytes, _ := io.ReadAll(resp.Body)
  fmt.Println("Resp: %s", respBytes)
  }
      `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
  String appId = "*** your appId ***";
  String appSecret = "*** your appSecret ***";
  // With request params
  String path = "${FAILT_LIST_}";
  
  // params
  byte[] requestBody = "".getBytes(StandardCharsets.UTF_8);
  // Sign
  long timestamp = new Date().getTime() / 1000L;
  String signText = appId + timestamp;
  if (requestBody.length != 0) {
  signText += new String(requestBody, StandardCharsets.UTF_8);
  }
  Mac sha256Hmac = Mac.getInstance("HmacSHA256");
  SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
  sha256Hmac.init(secretKey);
  byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
  String sign = byteArrayToHexString(signBytes);
  
  // Making API call
  HttpClient client = HttpClientBuilder.create().build();
  HttpPost request = new HttpPost(path);
  request.setHeader("Appid", appId);
  request.setHeader("Sign", sign);
  request.setHeader("Timestamp", String.valueOf(timestamp));
  request.setEntity(new ByteArrayEntity(requestBody));
  HttpResponse response = client.execute(request);
  BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
  StringBuilder responseText = new StringBuilder();
  String line;
  while ((line = reader.readLine()) != null) {
  responseText.append(line);
  }
  reader.close();
  
  // result
  System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
  StringBuilder hs = new StringBuilder();
  String tempStr;
  for (int index = 0; bytes != null && index < bytes.length; index++) {
  tempStr = Integer.toHexString(bytes[index] & 0XFF);
  if (tempStr.length() == 1) {
      hs.append('0');
  }
  hs.append(tempStr);
  }
  return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  import { coin_withdraw_fee_list } from './CoinWithdrawFeeList';
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${FAILT_LIST_}"
  content = {}
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
  sign_text = f"{sign_text}{body}"
  else:
  body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${FAILT_LIST_}';
  const args = '';
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
  signText += args;
  }
  
  const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');
  
  const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
  };
  
  const req = https.request(path, options, (res) => {
  let respData = '';
  
  res.on('data', (chunk) => {
  respData += chunk;
  });
  
  res.on('end', () => {
  console.log('Response:', respData);
  });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${FAILT_LIST_}";
  $content = [];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
      $sign_text = $sign_text . $body;
  } else {
      $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
      "headers" => array(
          "Content-Type: application/json;charset=utf-8",
          "Appid: " . $app_id,
          "Sign: " . $server_sign,
          "Timestamp: " . $timestamp
      ),
      "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <div>
      {/* 获取法定货币列表 */}
      <ContentWrap
        id="get-fiat-list"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("public_resource.get_coin_list_res_table_desc_1")}
            </Box>
            <Box className="desc">
              {translate("public_resource.get_coin_list_res_table_desc_2")}
            </Box>
            <Box className="title_1">{translate("common.http_request")}</Box>
            <Box className="desc link">
              <PostRequest url={FAILT_LIST} />
            </Box>
            <Box className="title_1">{translate("common.http_params")}</Box>
            <Table
              isEmpty={true}
              isEmptyText={translate("common.no_requset_param")}
              tableData={[]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={fait_list[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取法定货币列表 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.fiats",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.fiats[index].fiatId",
                  type: "Integer",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_3"
                  )}`,
                },
                {
                  name: "data.fiats[index].symbol",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_4"
                  )}`,
                },
                {
                  name: "data.fiats[index].logoUrl",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_5"
                  )}`,
                },
                {
                  name: "data.fiats[index].mark",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_6"
                  )}`,
                },
                {
                  name: "data.fiats[index].usdRate",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_7"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["fait_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
